<template>
	<side-window :tabs="tabs" :active="active" class="contact" title="SMS" @pop="$emit('pop')" @close="$emit('close')" @tabSelect="tabSelect">
		<div>
			<form-grid-layout>
				<div v-show="active == 'details'">
					<text-view label="Besked" v-model="entity.message" :height="700" />
				</div>
				<div v-show="active == 'recipients'">
					<text-view label="Modtagere" v-model="entity.recipients" :height="700" />
				</div>
			</form-grid-layout>
		</div>
		<div slot="footer">
			<button-view label="Send" @click="onSendButtonClick" />
		</div>
	</side-window>
</template>

<script>
	import TextView from '../views/TextView';
	import merge from '../functions/merge'

	export default {
		data: function () {
			return {
				active: 'details'
			};
		},
		components: {
			'TextView': TextView
		},
		computed: {
			tabs: function () {
				return [
					{
						name: 'details',
						label: 'Besked'
					},
					{
						name: 'recipients',
						label: 'Modtagere'
					}
				];
			}
		},
		props: {
			submit: {
				type: Function,
				default: function () { return true; }
			},
			entity: {
				type: Object,
				default() {
					return merge({}, {
						recipients: '',
						message: ''
					});
				}
			}
		},
		methods: {
			tabSelect(name, tabName) {
				this.active = tabName;
			},
			onSendButtonClick() {
				this.submit(merge({}, this.entity));
			}
		}
	}
</script>

<style lang="scss">
	
</style>